import { render, staticRenderFns } from "./PainelNotasWebhook.vue?vue&type=template&id=4cf562d7&scoped=true&"
import script from "./PainelNotasWebhook.vue?vue&type=script&lang=js&"
export * from "./PainelNotasWebhook.vue?vue&type=script&lang=js&"
import style0 from "./PainelNotasWebhook.vue?vue&type=style&index=0&id=4cf562d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf562d7",
  null
  
)

export default component.exports